import React from 'react';
import './CustomHyperlink.scss';
export const CustomHyperlink = ({ link, text, descp = '', styleClass = '', }) => (React.createElement("div", { className: "custom-hyperlink" },
    React.createElement("p", { className: styleClass },
        descp,
        " ",
        React.createElement("a", { href: link }, text))));
//# sourceMappingURL=CustomHyperlink.js.map